'use strict'
import scrollToElement from 'helpers/scrollToElement';

// Use this method to append listen for scroll to a specific element.
function initScrollElement(className, clickableElement, event) {
  let el = document.querySelector(className);
  let destinationEl;

  if(el) {
    destinationEl = document.querySelector(el.getAttribute('href'));
  }

  if(destinationEl) {
    el.addEventListener('click', e => {
      e.preventDefault();
      scrollToElement(destinationEl);
      openAccordion(destinationEl, event);
      if(clickableElement) document.querySelector(clickableElement).click()
    })
  }
}

function init() {

  document.body.addEventListener('click', function(e){
    if (e.target.getAttribute('data-skiplink')) {
      let destinationEl = document.querySelector(e.target.getAttribute('href') || e.target.getAttribute('data-skiplink-destination'));
      if(destinationEl) {
        e.preventDefault();
        scrollToElement(destinationEl);
        openAccordion(destinationEl);
      }
    }
  });
}

export const openAccordion = (section, event) => {
  let button = section.querySelector('h2 button');
  let content = section.querySelector('.accordion-js-enabled div');
  if (button && !content.getAttribute('style') == '') {
    if(event) {
      window.dispatchEvent(event);
    }
    button.click();
  }
};


if ('querySelector' in document && ('CustomEvent' in window)) {
  init();
}

export default initScrollElement;
